import { c as _c } from "react/compiler-runtime";
import { CircleSpinner, Flexbox, LogoSpinner } from '@newfront-insurance/core-ui';
import { useRouter, type Route } from '@newfront-insurance/next-router-provider';
import type { ReactNode, JSX } from 'react';
import { Suspense } from 'react';
import { AppHeader } from '../app-header';
import { InternalAppErrorBoundary } from '../error-boundary';
interface Props {
  children: ReactNode;
  disableHomeLink?: boolean;
  homeRoute?: Route;
  leftToolbar?: ReactNode;
  rightToolbar?: ReactNode;
  isShowingDarkSidebar?: boolean;
  showDarkModeToggle?: boolean;
}
export function AppLayout(props) {
  const $ = _c(16);
  const {
    children,
    disableHomeLink,
    homeRoute,
    leftToolbar,
    rightToolbar,
    showDarkModeToggle,
    isShowingDarkSidebar: t0
  } = props;
  const isShowingDarkSidebar = t0 === undefined ? false : t0;
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["/accounts", "/accounts/[accountUuid]/exposures", "/billing", "/coverage-gap-analysis"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const pathsToIgnore = t1;
  const showAppHeader = !isShowingDarkSidebar || isShowingDarkSidebar && pathsToIgnore.includes(router.router.pathname);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LogoSpinner />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      overflow: "hidden",
      height: "100vh"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== disableHomeLink || $[4] !== homeRoute || $[5] !== leftToolbar || $[6] !== rightToolbar || $[7] !== showAppHeader || $[8] !== showDarkModeToggle) {
    t4 = showAppHeader && <AppHeader disableHomeLink={disableHomeLink} homeRoute={homeRoute} leftToolbar={leftToolbar} rightToolbar={rightToolbar} showDarkModeToggle={showDarkModeToggle} />;
    $[3] = disableHomeLink;
    $[4] = homeRoute;
    $[5] = leftToolbar;
    $[6] = rightToolbar;
    $[7] = showAppHeader;
    $[8] = showDarkModeToggle;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CircleSpinner />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== children) {
    t6 = <InternalAppErrorBoundary><Suspense fallback={t5}>{children}</Suspense></InternalAppErrorBoundary>;
    $[11] = children;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <Suspense fallback={t2}><InternalAppErrorBoundary><Flexbox flexDirection="column" width="100vw" style={t3}>{t4}{t6}</Flexbox></InternalAppErrorBoundary></Suspense>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}